export const REST_BASE_URL = 'turrecoursecockpit';
export const REST_BASE_URL_WR = 'turwarrantyrecourse';
export const LOGIN_FALLBACK = 'turrecoursecockpit/_login.html';
const SERVICE_URI = '/service/v1';

export const completeEndpoint = (endpointPart: EndpointPart): string => {
  if (endpointPart === EndpointPart.LOGIN_SERVICE) {
    return `${REST_BASE_URL}${endpointPart}`;
  }
  return `${REST_BASE_URL}${SERVICE_URI}${endpointPart}`;
};

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum EndpointPart {
  GET_BOOKING_OVERVIEW = '/recoursebooking',
  GET_BOOKING_DETAILS = '/recoursebooking/{recourseBookingId}',
  PUT_BOOKING_DETAILS = '/recoursebooking/{recourseBookingId}',
  CANCEL_BOOKING = '/recoursebooking/cancelbooking/{recourseBookingId}',
  PATCH_START_APPROVAL_BOOKING = '/recoursebooking/startapproval/{recourseBookingId}',
  POST_NEW_RECOURSE_BOOKING = '/recoursebooking',
  GET_BOOKING_PENDING_APPROVALS = '/recoursebooking/pendingapprovals',
  GET_RECOURSE_CAMPAIGN = '/recourseCampaign',
  GET_RECOURSE_CAMPAIGN_DETAILS = '/recourseCampaign/recourseCampaignDetails/{campaignRecourseId}',
  GET_RECOURSE_CAMPAIGN_EX_DETAILS = '/recourseCampaign/recourseCampaignDetails/{campaignRecourseId}/extendedId/{campaignRecourseExId}',
  PUT_RECOURSE_CAMPAIGN_DETAILS = '/recourseCampaign/recourseCampaignDetails/{campaignRecourseId}',
  POST_DUPLICATE_CAMPAIGN = '/recourseCampaign/duplicateCampaign',
  PATCH_APPROVE_BOOKING = '/recoursebooking/approve/{recourseBookingId}',
  POST_APPROVE_AUTOMATED_AFTERSALES_BOOKINGS = '/recoursebooking/approveAllAftersales',
  PATCH_REPROCESS_BOOKING = '/recoursebooking/reprocess/{recourseBookingId}',
  POST_START_APPROVAL_NEW_BOOKING = '/recoursebooking/startApproval/new',
  GET_SUPPLIER = '/supplier/{supplierId}',
  GET_ALL_SUPPLIER_IDS = '/supplier/supplierids/{supplierIdPrefix}',
  GET_ALL_CURRENCY_KEYS = '/currencyKeys',
  GET_RECOURSE_CAMPAIGN_STATE = '/recourseCampaignState',
  GET_USER_BY_RIGTH_NAME = '/user/usersByRightName/{rightName}',
  GET_USER_FULL_NAME = '/user/userFullName/{ppnUserId}',
  GET_REFERENCE_BOOKINGS = '/recoursebooking/{referencedBookingId}/referencebookings',
  POST_UPLOAD_ATTACHMENT = '/attachment/file',
  GET_ALL_ATTACHMENTS_BY_TOPIC = '/attachment/{topic}',
  GET_ALL_ATTACHMENTS_BY_CAMPAIGN_TOPIC = '/attachment/campaign/{recourseId}/{topic}',
  GET_ALL_ATTACHMENTS_BY_BOOKING = '/attachment/recoursebooking/{recourceBookingId}',
  GET_DOWNLOAD_ATTACHMENT_BY_ID = '/attachment/download/{pkAttachmentId}',
  DELETE_ATTACHMENT_BY_ID = '/attachment/delete/{pkAttachmentId}',
  LOGIN_SERVICE = '/loginservice/v1/',
  GET_BOOKING_APPROVALS_HISTORY = '/bookingapprovals/history/{recourseBookingId}',
  GET_URL_QPP_SYS_RESERVE = '/url/getQPPSysReserveUrl',
  GET_CURRENT_CURRENCY_RATE = '/currency/{currencyKey}/{currencyRateDate}',
  POST_TABLE_VIEW_REGISTERED_USER = '/tableView/registeredUser',
  GET_TABLE_VIEW_REGISTERED_USER = '/tableView/registeredUser/{tableViewArea}',
  DELETE_TABLE_VIEW_REGISTERED_USER = '/tableView/registeredUser/{tableViewId}',
  PUT_TABLE_VIEW_REGISTERED_USER = '/tableView/registeredUser',
  GET_AFTER_SALES = '/afterSales',
  GET_AFTER_SALES_DETAILS = '/afterSales/{auditReportId}',
  POST_NEW_ADDITIONAL_COST = '/afterSales/additionalCosts',
  GET_ADDITIONAL_COST_CATEGORY_LIST = '/afterSales/additionalCostsCategory',
  PUT_UPDATE_ADDITIONAL_COST = '/afterSales/additionalCosts/{additionalCostId}',
  DELETE_ADDITIONAL_COST = '/afterSales/additionalCosts/{additionalCostId}',
  GET_ERROR_COST_RATES = '/afterSales/errorCostRates',
  POST_ERROR_COST_RATE = '/afterSales/errorCostRates',
  PUT_ERROR_COST_RATE = '/afterSales/errorCostRates',
  GET_SUPPLIER_EXCEPTIONS = '/supplierExceptions',
  POST_NEW_SUPPLIER_EXCEPTION = '/supplierExceptions',
  PUT_SUPPLIER_EXCEPTION = '/supplierExceptions',
  DELETE_SUPPLIER_EXCEPTION = '/supplierExceptions/{supplierId}/{exclusionFromDate}',
  GET_CURRENCY_CONVERT_AMOUNT_TO_SPECIFIC_CURRENCY = '/currencyKeys/convertAmountToSpecificCurrency/{amount}/{amountCurrencyUnit}/{amountCurrencyUnitToTransform}/{currencyUnitToTransformRateDate}',
  GET_ALL_CLAIM_RECOURSE = '/claimRecourse',
  GET_RECOURSE_CLAIM_INDEX_FROM_INDEX_TO = '/claimRecourse/{indexFrom}/{indexTo}',
  GET_RECOURSE_CLAIM_QUERY = '/claimRecourseSapDs',
  SEARCH_PARAMS = '/claimRecourseSapDs/searchKeysWithSearchOptions',
  SEARCH = '/claimRecourseSapDs/searchByParam',
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */
